'use client';

import { API_ROUTES, useApiInvalidate, useApiMutation } from '@shared/api-utils';
import { useSession } from '@shared/auth';
import type { CreatePayoutRequest, MonolithPayOutResponse } from '../types';

/**
 * Creates a payout and refreshes the wallet once it succeeds.
 */
function useCreatePayout() {
  const { session } = useSession();
  const playerId = session?.profile?.id;
  const { invalidateQuery } = useApiInvalidate();

  return useApiMutation<MonolithPayOutResponse, CreatePayoutRequest>(API_ROUTES.PAYMENTS.PAYOUTS.CREATE_PAYOUT, 'POST', {
    requestOptions: { credentials: true },
    mutationOptions: {
      onSuccess: () => {
        if (playerId) {
          invalidateQuery(API_ROUTES.MY_ACCOUNT.WALLET.GET_TRANSACTIONS.replace(':playerId', playerId));
        }
        invalidateQuery(API_ROUTES.MY_ACCOUNT.WALLET.GET_BALANCE);
      },
    },
  });
}

export { useCreatePayout };
